// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7de3b716","239":"fcd52ed8","453":"9c5125e5","667":"477911f3"}[chunkId] + ".chunk.js";
};